var App = App || {};

App.ScrollButton = (function ($) {
    'use strict';

    const BASE_CLEARANCE = 16;
    const FADE_DELAY_MS = 1500;
    let fadeTimeoutId = null;
    let fadeSequenceStarted = false;

    function getFixedBottomOffset() {
        const $cookieNotice = $('#CookieNotice:visible');

        if (!$cookieNotice.length) {
            return 0;
        }

        return $cookieNotice.outerHeight() + BASE_CLEARANCE;
    }

    function clearFadeTimer() {
        if (fadeTimeoutId) {
            clearTimeout(fadeTimeoutId);
            fadeTimeoutId = null;
        }
    }

    function startFadeSequence($root, scrollTop, maxScrollTop) {
        if (fadeSequenceStarted || scrollTop <= 0 || maxScrollTop <= 0) {
            return;
        }

        fadeSequenceStarted = true;
        fadeTimeoutId = setTimeout(function () {
            $root.addClass('scroll-button--faded');
            clearFadeTimer();
        }, FADE_DELAY_MS);
    }

    function updateIndicatorState($root, shouldScheduleFade) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const maxScrollTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const fixedBottomOffset = getFixedBottomOffset();

        $root.css('--scroll-button-bottom-offset', `${fixedBottomOffset}px`);

        // Hide the control entirely when there is no available page scroll.
        $root.toggleClass('scroll-button--hidden', maxScrollTop <= 0);

        if (shouldScheduleFade === true) {
            startFadeSequence($root, scrollTop, maxScrollTop);
        }
    }

    function Init() {
        const $root = $('[data-scroll-button]');

        if (!$root.length) {
            return;
        }

        $(window)
            .off('scroll.scrollButton resize.scrollButton')
            .on('scroll.scrollButton', function () {
                updateIndicatorState($root, true);
            })
            .on('resize.scrollButton', function () {
                updateIndicatorState($root, false);
            });

        updateIndicatorState($root, false);
    }

    return {
        Init: Init
    };

})(jQuery);